
import React, { Component, PureComponent } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { pushEventToGTM } from '../../../helpers/trackerManager';

import { CheckBox, Button } from "../../Forms/Forms";
import ForfaitRegularItem from './forfaitRegularItem';
import CONSTANTS from '../../../constants';

const mapStateToProps = state => state;

class BesoinsDetailsListRegular extends PureComponent {
  static defaultProps = {
    className: "",
    data: {},
    numberOfselected: 0,
  };
  constructor(props) {
    super(props);
    this.state = {
      blockEmpty: true,
      selectedData: this.props.data,
      showItemDetails: false,
      numberOfselected: 0,
    }
    this.selectThatForfait = this.selectThatForfait.bind(this);
  }
  componentDidMount() {
    console.warn(this.props.numberOfselected);
    this.setState({ numberOfselected: (this.props.numberOfselected ? this.props.numberOfselected + 1 : this.props.numberOfselected) })

  }
  selectThatForfait(isChecked, id) {
    let numberOfselected = this.state.numberOfselected;
    let data = JSON.parse(JSON.stringify(this.state.selectedData));
    const dataUpdatedWithSelectedForfaits = data.map(function (forfaitType, key) {
      forfaitType.SubFunctionList[0].ForfaitList = forfaitType.SubFunctionList[0].ForfaitList.map(function (forfait, keyforfait) {
        if (forfait.Items[0].Ref == id)
          if (isChecked) {
            forfait['isSelected'] = true;
            numberOfselected++;
          }
          else {
            forfait['isSelected'] = false;
            numberOfselected--;
          }
        return forfait;
      });
      return forfaitType;
    });
    this.setState({ selectedData: dataUpdatedWithSelectedForfaits, numberOfselected: numberOfselected });
  }


  render() {
    return (
      <div className="family-services__list services-wrapper">
        <div className="serices__items">

          {this.state.selectedData.map(function (forfaitType, key) {
            let showGroupTitle = true;
            return forfaitType.SubFunctionList.length && forfaitType.SubFunctionList[0].ForfaitList.map(function (forfait, keyforfait) {
              return (<React.Fragment key={keyforfait + '-' + key}>
                <ForfaitRegularItem
                  data={forfait}
                  key={forfait.Items[0].Ref}
                  forfaitCatTitle={(showGroupTitle ? forfaitType.Title : false)}
                  selectThatForfait={(isChecked, ref) => this.selectThatForfait(isChecked, ref)} />
                {showGroupTitle = false}
              </React.Fragment>
              )

            }.bind(this))
          }.bind(this))}
          <div className="serices__items_footer footer-wrapper">
            <div className="serices__items_footer block_footer_form">
              <Button onClick={() => {
                this.props.getSelectedForfait(this.state.selectedData);

                pushEventToGTM({
                  pageName: 'services',
                  eventAction: 'Click::CTA',
                  eventLabel: 'operations_add'
                });
              }}
                Disabled={this.state.numberOfselected < 1}>
                {CONSTANTS.LABELS.common_v2_add}
              </Button>
            </div>

            <div className="serices__items_footer block_footer_content">

              <p dangerouslySetInnerHTML={{ __html: (CONSTANTS.LABELS.needs_basket_label4) }}></p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default connect(mapStateToProps)(BesoinsDetailsListRegular);
